import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Login from './Component/Login';

const mapStateToProps = (state, ownProps) => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      errorCode: state.auth.errorCode,
      error: state.auth.error,
      message: state.auth.message
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
      loginUser: (payload, persistent) => dispatch(Actions.loginUser(payload, persistent)), // Action to login
      loginResponse: (response) => dispatch(Actions.loginResponse(response)),
      setLoader: () => dispatch(Actions.setLoader()),
      unsetLoader: () => dispatch(Actions.unsetLoader()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)

